import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "t2-main" }
const _hoisted_2 = { class: "t2-content" }
const _hoisted_3 = {
  class: "container",
  style: {"margin-top":"-40px"}
}
const _hoisted_4 = { class: "main_cont1" }
const _hoisted_5 = {
  class: "w_1200",
  style: {"padding-bottom":"50px"}
}
const _hoisted_6 = { class: "title_v1" }
const _hoisted_7 = { class: "tit_txt" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "table_form" }
const _hoisted_10 = { class: "yzm_td" }
const _hoisted_11 = {
  class: "title_v1",
  style: {"margin-top":"30px"}
}
const _hoisted_12 = { class: "tit_txt" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "table_form" }
const _hoisted_15 = { colspan: "4" }
const _hoisted_16 = {
  colspan: "5",
  class: "btn_row"
}

import { AREA_ID } from '@/config/const';
import {getAllDeptByRegionCode, sendCodeVerify, preComplainAdd, getUrl, getGovLoginUser} from '@/config/request';
import { ElMessage } from 'element-plus';
import { reactive, ref } from 'vue';
import { useStore } from 'vuex'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore()
const imgList = reactive({
    zx_icon: require('@/assets/images/zx_icon.png'),
    b_zx_icon: require('@/assets/images/b_zx_icon.png'),
    b_rimg1: require('@/assets/images/b_rimg1.png'),
    ts_icon2: require('@/assets/images/ts_icon2.png'),
})
const complainObj = reactive({
    departmentName: '',
    address: '',
    idCard: '',
    sex: '',
    departmentid: '',
    querynum: '',
    telephone: '',
    becomplainedWorkUtil: '',
    type: '',
    content: '',
    hfnr: '',
    maintitle: '',
    becomplainedName: '',
    name: '',
    tslx: '',
    becomplainedDuty: '',
    email: '',
    createUserId: '',
    departmentAreacode: '',
})

let options = ref([]) as any
let yzmNum = ref('')
let yzm = ref('获取验证码')
let disabled = ref(false)
let numSix = ''
let counter = ref(60)
const verify = () => { //  验证码
    if (numSix && (numSix === yzmNum.value)) {
        return true
    } else {
        ElMessage.error('验证码验证失败！')
        return false
    }
}
const getCode = async () => {
    if (complainObj.telephone.length != 11) {
        ElMessage.error('手机号码错误！')
        return false
    }
    disabled.value = true
    let intervalNum = setInterval(() => {
        counter.value--
        yzm.value = `验证码(${counter.value})`
        if (counter.value < 1) {
            clearInterval(intervalNum)
            yzm.value = '获取验证码'
            counter.value = 60
            disabled.value = false
        }
    }, 1000)
    //  6位随机数
    numSix = String(Math.floor(Math.random() * 900000) + 100000)
    let param = {
        userphone: complainObj.telephone,
        code: numSix,
    }
    const res = await sendCodeVerify(param) as any
    console.log('验证码---------：', res)
    if (res.code == 200) {
        console.log('发送成功！')
    } else {
        console.log('发送失败!')
    }
}
const verify2 = () => {  //  输入框
    if (complainObj.name && complainObj.telephone && yzmNum && complainObj.maintitle &&
        complainObj.content && complainObj.departmentid
    ) {
        return true
    } else {
        ElMessage.warning('必填项有空值！')
        return false
    }
}
const submit = async () => {
    if (!verify2()) {
        return false
    }
    if (verify()) {
        for (let obj of options.value) {
            if (obj.departmentId == complainObj.departmentid) {
                complainObj.departmentName = obj.departmentName
                break
            }
        }
        complainObj.type = '1'  //  咨询
        //complainObj.departmentAreacode = ''
        const res = await preComplainAdd(complainObj) as any
        let parse = JSON.parse(res.result || {})
        if (parse.code == 200) {
            ElMessage.success('提交成功！')
            init()
            yzmNum.value = ''
            yzm.value = '获取验证码'
        } else {
            ElMessage.error('提交失败！')
        }
    }
}
const init = async () => {
    let data = store.state.userInfomation
    /*let data = {
        "id": "41020016854331673168577",
        "cuserId": "41020016854331673168577",
        "userType": "1",
        "userName": "李宏博",
        "certType": "111",
        "certNo": "410223198703050038",
        "userMobile": "13468629192",
        "userRealLvl": "RC03",
        "effDate": "20181229",
        "expDate": "20381229",
        "certificateSno": null,
        "corpType": null,
        "corpName": null,
        "createTime": "2023-05-30 15:52:47",
        "modifyTime": "2023-05-30 15:52:47",
        "extend1": null,
        "extend2": null,
        "extend3": null
    }*/
    // 四个必须的参数
    complainObj.createUserId = data.cuserId; // 省用户id
    complainObj.name = data.userName;  // 用户姓名
    complainObj.telephone = data.userMobile; // 手机号码
    complainObj.idCard = data.certNo;  // 身份证号

    let param = {
        regionCode: AREA_ID
    }
    const res = await getAllDeptByRegionCode(param) as any

    options.value = res.result.result || [];
}
init()

return (_ctx: any,_cache: any) => {
  const _component_Top = _resolveComponent("Top")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Top, { fixedNobanner: true }),
    _cache[24] || (_cache[24] = _createElementVNode("div", {
      class: "no_banner",
      id: "no_banner"
    }, null, -1)),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "container mar_b" }, [
            _createElementVNode("div", { class: "t6_breadCream" }, [
              _createElementVNode("span", null, "首页"),
              _createElementVNode("i", null, ">"),
              _createTextVNode(),
              _createElementVNode("span", null, " 我要咨询")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("img", {
                      src: imgList.zx_icon
                    }, null, 8, _hoisted_8),
                    _cache[7] || (_cache[7] = _createElementVNode("span", null, "政务咨询", -1)),
                    _cache[8] || (_cache[8] = _createElementVNode("span", { class: "small" }, "（如果您需要咨询有关政府部门的问题，请在此咨询，我们将为您跟进处理）", -1))
                  ])
                ]),
                _createElementVNode("table", _hoisted_9, [
                  _cache[15] || (_cache[15] = _createElementVNode("colgroup", null, [
                    _createElementVNode("col", { width: "86" }),
                    _createElementVNode("col", { width: "471" }),
                    _createElementVNode("col", { width: "86" }),
                    _createElementVNode("col", { width: "86" }),
                    _createElementVNode("col")
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[9] || (_cache[9] = _createElementVNode("th", null, [
                        _createElementVNode("span", { class: "red_color" }, "*"),
                        _createElementVNode("span", { class: "span2" }, "姓名"),
                        _createTextVNode("：")
                      ], -1)),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_input, {
                          modelValue: complainObj.name,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((complainObj.name) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _cache[10] || (_cache[10] = _createElementVNode("td", null, null, -1)),
                      _cache[11] || (_cache[11] = _createElementVNode("th", null, [
                        _createElementVNode("span", { class: "red_color" }, "*"),
                        _createElementVNode("span", { class: "span2" }, "手机号码"),
                        _createTextVNode("：")
                      ], -1)),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_input, {
                          modelValue: complainObj.telephone,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((complainObj.telephone) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[12] || (_cache[12] = _createElementVNode("th", null, [
                        _createElementVNode("span", { class: "red_color" }, "*"),
                        _createElementVNode("span", { class: "span2" }, "验证码"),
                        _createTextVNode("：")
                      ], -1)),
                      _createElementVNode("td", _hoisted_10, [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(yzmNum),
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(yzmNum) ? (yzmNum).value = $event : yzmNum = $event)),
                          placeholder: "请输入内容",
                          type: "number",
                          style: {"width":"calc(100% - 140px)"}
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_el_button, {
                          class: "fr",
                          disabled: _unref(disabled),
                          type: "primary",
                          onClick: getCode
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(yzm)), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _cache[13] || (_cache[13] = _createElementVNode("td", null, null, -1)),
                      _cache[14] || (_cache[14] = _createElementVNode("th", null, [
                        _createElementVNode("span", { class: "red_color" }),
                        _createElementVNode("span", { class: "span2" }, "电子邮件"),
                        _createTextVNode("：")
                      ], -1)),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_input, {
                          modelValue: complainObj.email,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((complainObj.email) = $event)),
                          placeholder: "请输入内容"
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("img", {
                      src: imgList.ts_icon2
                    }, null, 8, _hoisted_13),
                    _cache[16] || (_cache[16] = _createElementVNode("span", null, "咨询内容", -1))
                  ])
                ]),
                _createElementVNode("table", _hoisted_14, [
                  _cache[22] || (_cache[22] = _createElementVNode("colgroup", null, [
                    _createElementVNode("col", { width: "86" }),
                    _createElementVNode("col", { width: "471" }),
                    _createElementVNode("col", { width: "86" }),
                    _createElementVNode("col", { width: "86" }),
                    _createElementVNode("col")
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[17] || (_cache[17] = _createElementVNode("th", null, [
                        _createElementVNode("span", { class: "red_color" }, "*"),
                        _createElementVNode("span", { class: "span2" }, "标题"),
                        _createTextVNode("：")
                      ], -1)),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_input, {
                          modelValue: complainObj.maintitle,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((complainObj.maintitle) = $event)),
                          placeholder: "请输入内容"
                        }, null, 8, ["modelValue"])
                      ]),
                      _cache[18] || (_cache[18] = _createElementVNode("td", null, null, -1)),
                      _cache[19] || (_cache[19] = _createElementVNode("th", null, [
                        _createElementVNode("span", { class: "red_color" }, "*"),
                        _createElementVNode("span", { class: "span2" }, "咨询部门"),
                        _createTextVNode("：")
                      ], -1)),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_el_select, {
                            modelValue: complainObj.departmentid,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((complainObj.departmentid) = $event)),
                            placeholder: "请选择部门",
                            style: {"width":"100%","border":"none"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.departmentId,
                                  label: item.departmentName,
                                  value: item.departmentId
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[20] || (_cache[20] = _createElementVNode("th", {
                        valign: "top",
                        style: {"padding-top":"20px"}
                      }, [
                        _createElementVNode("span", { class: "red_color" }, "*"),
                        _createElementVNode("span", { class: "span2" }, "内容描述"),
                        _createTextVNode("： ")
                      ], -1)),
                      _createElementVNode("td", _hoisted_15, [
                        _createVNode(_component_el_input, {
                          type: "textarea",
                          rows: 4,
                          modelValue: complainObj.content,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((complainObj.content) = $event)),
                          style: {"text-indent":"2rem"}
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_16, [
                        _createVNode(_component_el_button, {
                          class: "form_btn2",
                          type: "primary",
                          onClick: submit
                        }, {
                          default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                            _createElementVNode("span", null, "提 交", -1)
                          ]))]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Bottom)
  ], 64))
}
}

})